<div class="mb-4 mb-xl-0 text-center text-md-start shadow-register p-3 mb-5 bg-white corner-radius">
  <div>
    <div class="card-body p-6">
      <div class="mb-4" style="padding: 0px 20px 0px 20px;">
        <label class="title">Log in to SwiftChat Admin Manager</label>
        <label class="sub-title">Enter your log in credentials to verify all businesses</label>
      </div>
      <div class="row">
        <div class="jumbotron">
          <div class="container">
              <app-alert></app-alert>
          </div>
        </div>
      </div>
      <form [formGroup]="adminLoginFormGroup"  (ngSubmit)="onSubmit()" fxLayout="column"fxLayoutGap="15px"> 
        <mat-form-field class="admin-login">
            <mat-label >Email ID</mat-label>
            <input  matInput placeholder="email@example.com" formControlName="email" required>
            <mat-error
              *ngIf="adminLoginFormGroup.controls.email.invalid && adminLoginFormGroup.controls.email.errors.required">
               Email Id is <strong>required</strong>
            </mat-error>
            <mat-error
              *ngIf="adminLoginFormGroup.controls.email.invalid && adminLoginFormGroup.controls.email.errors.email">
              Please Enter Valid Email ID
            </mat-error>
          </mat-form-field>
          <mat-form-field class="admin-login">
            <mat-label >Password</mat-label>
            <input  matInput type="password" placeholder="password" formControlName="password" required>
            <mat-error
              *ngIf="adminLoginFormGroup.controls.password.invalid && adminLoginFormGroup.controls.password.errors.required">
              Password is <strong>required</strong>
            </mat-error>
            <mat-error
              *ngIf="adminLoginFormGroup.controls.password.invalid && adminLoginFormGroup.controls.password.errors.email">
              Please enter password
            </mat-error>
          </mat-form-field>
          <div fxLayoutAlign="start center" fxLayoutGap="5px">
            <input type="checkbox" id="rememberMe" />
            <label for="rememberMe" class="form-check-label" style="font-size:13px;">Remember Me</label>
               
        </div>
        <div fxLayoutAlign="center center">
          <button  class="login-btn">Log in</button>
      </div>  
      </form>
    </div>
  </div>
</div>